// extracted by mini-css-extract-plugin
export default {"root":"AssistantBlock_root__2utvd"};